import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
import { keys } from '@/api/queryKeys';
import { emailApi } from '../api/emailApi';

/** FD125 — POST read receipt once per open thread (GET detail alone does not record). */
export function useEmailThreadRead(messageId: string | null, providerThreadId: string | null) {
  const queryClient = useQueryClient();
  const markedKeyRef = useRef<string | null>(null);

  useEffect(() => {
    if (!messageId || !providerThreadId) return;

    const key = `${messageId}:${providerThreadId}`;
    if (markedKeyRef.current === key) return;
    markedKeyRef.current = key;

    void emailApi
      .markThreadRead(providerThreadId)
      .then(() => {
        void queryClient.invalidateQueries({ queryKey: keys.email.message(messageId) });
        void queryClient.invalidateQueries({ queryKey: keys.email.messages() });
      })
      .catch(() => {
        markedKeyRef.current = null;
      });
  }, [messageId, providerThreadId, queryClient]);
}
